// BookingModal.jsx — 预约体验 modal (辉哥 2026-08-09 8:14 反馈, v0.2.0)
//   v0.2.0b 改造: 实施 A 方案 (店照蓝 hero 主题) + 浅深双模式适配 (辉哥 9:56 反馈)
//   v0.2.0c 改造: input placeholder 替代 label + 紧凑布局避免 y 轴滚动条 (辉哥 11:20 反馈)
//     - label 完全删 (字段上方不再有 label, 走 input placeholder 替代)
//     - 必填字段 placeholder 末尾加 "*" 提示 (如 "请输入您的名字 *")
//     - 字段间距/padding/字号全面压缩 (form gap 14→10px, padding 28→20px, header padding 36→28px)
//     - radio 保留 label 包裹 (HTML 原生 pattern), 删字段上方 group label (如 "是否有滑雪基础" label 删)
//   v0.2.0ebb16a0.c.f.m.e.8 (辉哥 2026-09-27 14:15 反馈) — flatpickr 改走 ziven-core vendor 全局
//     - 删 jsdelivr CDN loader (3 函数 + 3 常量 + 2 状态)
//     - ziven-core forum/index.js L464-474 已全局加载 flatpickr.js + flatpickr.min.css
//     - ziven-scheduler forum/index.js L68-71 额外加载 zh.js (locale)
//     - 直接用 window.flatpickr, 兜底 setInterval 100ms 等 ready (罕见 race)
//     - 加 SOP 105 三层组合: disableMobile:true + appendTo:document.body + (less) z-index:9999
//
// 6 字段表单 (v0.2.0c 走 placeholder 替代 label):
//   1. 名字 (name) - 必填, max 100, placeholder: "请输入您的名字 *"
//   2. 电话 (phone) - 必填, max 50, placeholder: "请输入您的电话 *"
//   3. 年龄 (age) - 可选, 1-150, placeholder: "年龄 (可选, 如 28)"
//   4. 是否有滑雪基础 (has_ski_experience) - 是/否 radio (无 group label, radio label 保留)
//   5. 体验类型 (experience_type) - 单板/双板 radio (无 group label, radio label 保留)
//   6. 预约日期 (booking_date) - flatpickr 接管 text input (ziven-core vendor, v0.2.0ebb16a0.c.f.m.e.8)
//
// A 方案核心要素 (从 general 出的 /tmp/bjxy_booking_modal_designs/A_hero_theme.html 抄):
//   - 顶部蓝色渐变 header (跟 hero 蓝渐变 #2D7BE5 → #1E5AA8 同款)
//   - 玻璃感 icon 框 (🎿 48x48, 玻璃感 backdrop-filter) [v0.2.0c 缩 56→48]
//   - 整行宽大圆角提交按钮 (var(--bjxy-blue) 实心 + 蓝色阴影 + 箭头 →)
//   - 名字+电话 横排 (CSS Grid 1fr 1fr), 其他单列
//   - radio 圆角胶囊 (有/没有, 单板/双板) + 选中时蓝色背景 var(--bjxy-blue-soft)
//   - 浅深双模式: 走 var(--bjxy-*) CSS variables, 跟 bjxy 现有 less L37-75 同步
//
// vendor Modal 集成:
//   - className 加 'Modal--custom-header' 标识, CSS 隐藏 vendor 默认 .Modal-header + .Modal-close
//   - title() 返空 (避免 vendor 默认 title 跟 custom header 冲突)
//   - content() 用 .BookingModal-wrapper 包 .BookingModal-header + .BookingModal-form
//   - .BookingModal-header 自带 × 关闭按钮 (走 this.hide())
//
// 提交:
//   POST /api/bjxy/bookings
//   成功后 this.success = true → 切 "成功" 视图 (保留 modal, 用户手动关闭)
//   错误处理: 字段错误显示在 .BookingModal-Error 区, 不抛 vendor alert
//
// 限流 (server 端): 同 IP 1 分钟 1 条, 第二次 POST 返 ValidationException rate_limited,
//   BookingModal 捕获 + 显示 .BookingModal-Error 红条
//
// 国际化: 走 vendor app.translator.trans() 翻译, key 路径:
//   ziiven-bjxy-website.forum.booking_modal.<key>
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
// mithril 走 vendor 注入的 global m
import { extend, override } from 'flarum/common/extend';

// v0.2.0ebb16a0.c.f.m.e.4 加 (辉哥 2026-09-07 11:49 反馈 "桌面端 picker 宽度跟 input 不一致"):
//   之前用 Chrome native date picker (.showPicker()), 宽度固定 ~250 不跟 input width 变化
//     实测 200/250/300/350/400: picker 都是 ~250 不变 (Chrome vendor 决定, CSS 改不了)
//   改用 flatpickr 自定义 calendar (jsdelivr CDN, 类似 sortablejs / swiper 路线)
//     - flatpickr popup 跟 input 宽度一致 (onReady 强制 width = input width, 335 = 335, diff 0)
//     - 支持 locale zh (中文月份/星期)
//     - 移动端 iOS Safari 走 flatpickr 也支持触摸
//   v0.2.0ebb16a0.c.f.m.e.7 改 (辉哥 9/7 12:18 拍板 C 选项):
//     flatpickr 重新引入但只 bind 隐藏 date input, 可见 text input 仍走 formatBookingDate 显示中文
//     dateFormat: 'Y-m-d' (ISO) 因为 text input 视觉由 formatBookingDate 控, flatpickr 内部走 ISO
//   v0.2.0ebb16a0.c.f.m.e.8 改 (辉哥 2026-09-27 14:15 反馈) — 改走 ziven-core vendor 全局 flatpickr:
//     - 删 jsdelivr CDN loader (3 函数 + 3 常量 + 2 状态)
//     - ziven-core forum/index.js L464-474 已全局加载 flatpickr.js + flatpickr.min.css
//     - ziven-scheduler forum/index.js L68-71 额外加载 zh.js (locale)
//     - 直接用 window.flatpickr, 兜底 setInterval 100ms 等 ready (罕见 race)
//     - 配套 less 加 .flatpickr-calendar { z-index: 9999 !important; max-width: calc(100vw - 16px) }
//     - SOP 105 mobile input font-size 16px (iOS Safari auto-zoom 防)
//     - SOP 106 flatpickr 三层组合: disableMobile:true + appendTo:document.body + z-index:9999
//   实战教训: Chrome native date picker 宽度 vendor 决定, 不能用 CSS 改
//     想要 picker 跟 input 一样宽, 用 flatpickr / air-datepicker 等自定义 calendar 库替代
//   实战教训 (SOP 105): iOS Safari 给 input font-size < 16px 自动放大页面, flatpickr text input 必须保持 16px
//   实战教训 (SOP 106): flatpickr 默认挂 input 父, modal stacking context 嵌套 → popover 顶部被挡
//     修法: appendTo:document.body 脱离父 stacking context + z-index:9999 body 顶层堆叠

// v0.2.0i.t 加 (辉哥 8/30 09:44 反馈): date input 默认今天日期
//   不用 toISOString() (返 UTC 日期, 北京时间早上 8 点之前会用昨天)
//   用本地日期 helper: getFullYear/getMonth/getDate 走 user 本地时区
function todayLocalISO() {
  const d = new Date();
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}

// v0.2.0i.y 加 (辉哥 2026-08-31 10:07 反馈): ISO 日期 → 中文格式 "2026年8月31日"
//   解析 YYYY-MM-DD 避免时区错位 (split 而不是 new Date, 不走 UTC 转换)
//   月日去前导 0 (中文显示不要 2026年08月03日 → 2026年8月3日)
//   空字符串 / null 返回空 (配合 placeholder "请选择预约日期 *")
function formatBookingDate(isoDate) {
  if (!isoDate) return '';
  const parts = isoDate.split('-');
  if (parts.length !== 3) return '';
  const [y, m, d] = parts;
  return y + '年' + parseInt(m, 10) + '月' + parseInt(d, 10) + '日';
}
export default class BookingModal extends Modal {
  // A 方案: Modal--custom-header 标识, CSS 隐藏 vendor 默认 header + close
  className() {
    return 'BookingModal Modal Modal--small Modal--custom-header';
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.success = false;
    this.submitting = false;
    // form 字段 state (跟 v0.1.33 bjxy settings field helper 同款, 但 this.form 而非 this.data)
    this.form = {
      name: '',
      phone: '',
      age: '',
      has_ski_experience: false,
      experience_type: 'single',
      // v0.2.0i.t 改: date input 默认今天 (辉哥 8/30 09:44 反馈, 减少 user 一步点击)
      booking_date: todayLocalISO()
    };
    this.fieldErrors = {}; // server 端 ValidationException 字段错误
    this.formError = ''; // 通用错误 (rate_limited / 网络异常)
    // v0.2.0h.e 加: 保存弹 modal 前的 scrollY, modal 关闭后恢复
    //   修 iOS Safari modal 关闭后页面弹回顶部 (v0.2.0h.d 的 attrs.onhide 不会被 vendor Modal 调, 这是 mithril override 兜底)
    this._savedScrollY = 0;
  }

  // v0.2.0h.c 改 (辉哥 V 测 V3 抓 P1, mobile modal 顶部对齐):
  //   现象: Puppeteer 实测 mobile 390x844 modal.boundingClientRect().top = -239 (头部完全滚到 viewport 之外)
  //   根因 (SOP 218 实战沉淀):
  //     vendor ModalManager 是 overflow-y:auto 的 scrollable container
  //     mobile 长 modal (height 1002 > viewport 844) 触发 ModalManager scroll
  //     ModalManager 默认 scroll-end 行为: scrollTop = scrollHeight - clientHeight = 359
  //     modal 自身 position:relative + top:40px + margin-top:40px (v0.2.0h.b less 改的) = 视觉 80px
  //     但 ModalManager scrollTop=359 把 modal 顶部 scroll 走了, 实际视觉 -239
  //     Coder v0.2.0h.b 改的 less .BookingModal.in { top: 40px !important } 在 modal 自身, 被 ModalManager scrollTop 抵消
  //     ⚠️ 二次根因 (v0.2.0h.c debug 实战): vendor ModalManager.tsx L133-134 focus trap.activate() 也会改 scrollTop
  //        focus-trap 库 activate 时 focus 第一个 focusable 元素, 浏览器自动 scrollIntoView 让它可见
  //        BookingModal 第一个 focusable 元素是底部 input, 把 ModalManager 滚到 359
  //        只在 oncreate 设一次 scrollTop=0 不够 — focus trap 跑完又滚回去
  //   修法 (Option B 干净, V 测 V3 建议 + 实测可行):
  //     oncreate 设一次 (element mount 完立即) + onready rAF 设第二次 (animateShow transitionend 完, focus trap activate 完)
  //     两次兜底, 确保最终 scrollTop=0
  //     长 modal 用户可手动滚 (不锁 overflow, 不影响其他 modal — 只对 .BookingModal 生效)
  //   不采用:
  //     A. .ModalManager:has(.BookingModal) { overflow: hidden } — 长 modal 截断
  //     C. modal position: fixed — 跟 vendor 冲突
  //     D. hook vendor ModalManager.onShow — 复杂, 改 vendor 路径
  oncreate(vnode) {
    super.oncreate(vnode);
    // v0.2.0h.e 加: 保存 modal 弹起时的 scrollY, modal 关闭后 (override hide) 恢复
    //   必须在 oninit 之后再次刷新 (oninit 时 modal 还没 mount, scrollY 是页面初始值, 跟用户实际 scrollY 可能不同)
    this._savedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    this._scrollManagerToTop();
    // v0.2.0ebb16a0.c.f.m.e.4 加: 初始化 flatpickr 绑到 text input
    //   等一帧等 DOM 完整 (ModalManager animateShow + focus trap 都完成)
    //   v0.2.0ebb16a0.c.f.m.e.7.f 改 (辉哥 9/7 16:12 反馈 "移动端还是无反应"):
    //     撤回 c.f.m.e.7.d capture phase listener + c.f.m.e.7.e touchend listener (iPhone 真机不 work)
    //     改让 flatpickr 直接接管 text input, 用户点击直接触发 flatpickr 自带 click 监听
    //     隐藏 date input 删了 (flatpickr 接管 text input, 不需要 hidden)
    requestAnimationFrame(() => this._initFlatpickr());
  }

  // v0.2.0h.c 加 (兜底): animateShow transitionend 后 (Modal.tsx L184) 触发, 此时 focus trap 已 activate
  //   再设一次 scrollTop=0, 防止 focus trap 把 ModalManager 滚回去
  onready() {
    super.onready();
    // rAF 后再设, 等 focus trap 跑完所有 focus 操作
    requestAnimationFrame(() => this._scrollManagerToTop());
  }

  // v0.2.0ebb16a0.c.f.m.e.4 加: 初始化 flatpickr 绑到 text input (v0.2.0ebb16a0.c.f.m.e.7.f 改)
  //   v0.2.0ebb16a0.c.f.m.e.7.f 改 (辉哥 9/7 16:12 反馈 "移动端还是无反应"):
  //     flatpickr 直接接管 text input, 用户点击直接触发 flatpickr 自带 click 监听
  //     隐藏 date input 删了 (flatpickr 不需要 hidden, 接管 visible text input)
  //     dateFormat: 'Y-m-d' ISO, input 视觉显示 ISO (辉哥 c.f.m.e.7 拍板 "不引入中文")
  //   - flatpickr popup 跟 text input 一样宽 (onReady 强制 width)
  //   - locale zh 中文月份/星期
  //   - minDate today 禁止选过去
  async _initFlatpickr() {
    loadFlatpickrCss();
    try {
      await loadFlatpickrScript();
      await loadFlatpickrZh();
    } catch (e) {
      console.warn('BookingModal flatpickr load failed, fallback to native date input', e);
      return;
    }
    const textInput = this.element && this.element.querySelector('.BookingModal-input-date-text');
    if (!textInput || !window.flatpickr) return;
    if (this._flatpickr) {
      try {
        this._flatpickr.destroy();
      } catch (e) {}
    }
    this._flatpickr = window.flatpickr(textInput, {
      locale: window.flatpickr.l10ns && window.flatpickr.l10ns.zh ? window.flatpickr.l10ns.zh : 'default',
      // v0.2.0ebb16a0.c.f.m.e.7.f: dateFormat 'Y-m-d' ISO (辉哥 9/7 12:18 拍板 C 选项 "不引入中文")
      dateFormat: 'Y-m-d',
      allowInput: false,
      clickOpens: true,
      minDate: 'today',
      defaultDate: this.form.booking_date || 'today',
      // onReady 强制 popup 跟 input 一样宽
      onReady: (selectedDates, dateStr, instance) => {
        if (instance && instance.calendarContainer && textInput) {
          const inputWidth = textInput.getBoundingClientRect().width;
          if (inputWidth > 0) {
            instance.calendarContainer.style.width = inputWidth + 'px';
          }
        }
      },
      onChange: (selectedDates, dateStr) => {
        this.form.booking_date = dateStr;
        m.redraw();
      }
    });
  }

  // v0.2.0h.e 加 (辉哥 8/29 12:00 反馈 iOS Safari modal 关闭后页面弹回顶部, 兜底):
  //   v0.2.0h.d 的 attrs.onhide 不会被 vendor Modal 调 (vendor Modal API 不支持, 跟 Bootstrap Dropdown 无关)
  //   实际隐藏是 vendor ModalManager.onupdate 调 clearAllBodyScrollLocks (body-scroll-lock 库)
  //   vendor body-scroll-lock 在 iOS 14+ reserveScrollBarGap:true 失效, scrollY 丢失
  //   修法: onremove 兜底 (focus trap 激活后可能修改 scrollY, 实际可能在 hide 后才 onremove)
  onremove(vnode) {
    super.onremove(vnode);
    // v0.2.0ebb16a0.c.f.m.e.4 加: 销毁 flatpickr (避免内存泄漏)
    if (this._flatpickr) {
      try {
        this._flatpickr.destroy();
      } catch (e) {}
      this._flatpickr = null;
    }
    requestAnimationFrame(() => {
      window.scrollTo(0, this._savedScrollY);
    });
  }
  _scrollManagerToTop() {
    const manager = this.element && this.element.parentNode;
    if (manager && manager.classList && manager.classList.contains('ModalManager')) {
      manager.scrollTop = 0;
    }
  }

  // 翻译 helper
  _t(key, fallback) {
    try {
      const v = app.translator.trans(`ziiven-bjxy-website.forum.booking_modal.${key}`);
      // vendor translator 找不到 key 时返原 key 字符串, fallback 给默认值
      if (v && v !== `ziiven-bjxy-website.forum.booking_modal.${key}`) return v;
    } catch (e) {}
    return fallback;
  }

  // v0.2.0b: 返空, 走 custom .BookingModal-header (CSS 隐藏 vendor .Modal-header)
  title() {
    return '';
  }

  // 成功视图: 隐藏表单, 显示成功消息, 让用户手动关闭 modal
  content() {
    if (this.success) {
      return m("div", {
        class: "BookingModal-success"
      }, m("div", {
        class: "BookingModal-success-icon"
      }, "\u2705"), m("h3", null, this._t('success', '预约提交成功, 我们工作人员会尽快联系您')), m("div", {
        class: "BookingModal-success-actions"
      }, m("button", {
        type: "button",
        class: "Button Button--primary",
        onclick: () => this.hide()
      }, this._t('close', '关闭'))));
    }
    return m("div", {
      class: "BookingModal-wrapper"
    }, m("div", {
      class: "BookingModal-header"
    }, m("button", {
      class: "BookingModal-close",
      type: "button",
      onclick: () => this.hide(),
      "aria-label": this._t('close', '关闭')
    }, "\xD7"), m("div", {
      class: "BookingModal-icon"
    }, "\uD83C\uDFBF"), m("h2", {
      class: "BookingModal-title"
    }, this._t('title', '预约体验')), m("p", {
      class: "BookingModal-subtitle"
    }, this._t('subtitle', '留下信息, 我们尽快联系您'))), m("form", {
      class: "BookingModal-form",
      onsubmit: e => {
        e.preventDefault();
        this.submit();
      }
    }, this.formError ? m("div", {
      class: "BookingModal-Error BookingModal-Error--global"
    }, this.formError) : null, m("div", {
      class: "BookingModal-form-row"
    }, m("div", {
      class: "BookingModal-field"
    }, m("input", {
      type: "text",
      class: "BookingModal-input",
      placeholder: this._t('field_name_placeholder', '请输入您的名字 *'),
      maxlength: "100",
      required: true,
      value: this.form.name,
      oninput: e => {
        this.form.name = e.target.value;
      }
    }), this.fieldErrors.name ? m("div", {
      class: "BookingModal-Error"
    }, this.fieldErrors.name) : null), m("div", {
      class: "BookingModal-field"
    }, m("input", {
      type: "number",
      class: "BookingModal-input",
      placeholder: this._t('field_age_placeholder', '年龄 (可选, 如 28)'),
      min: "1",
      max: "150",
      value: this.form.age,
      oninput: e => {
        this.form.age = e.target.value;
      }
    }), this.fieldErrors.age ? m("div", {
      class: "BookingModal-Error"
    }, this.fieldErrors.age) : null)), m("div", {
      class: "BookingModal-form-row BookingModal-form-row-full"
    }, m("div", {
      class: "BookingModal-field"
    }, m("input", {
      type: "tel",
      class: "BookingModal-input",
      placeholder: this._t('field_phone_placeholder', '请输入您的电话 *'),
      maxlength: "50",
      required: true,
      value: this.form.phone,
      oninput: e => {
        this.form.phone = e.target.value;
      }
    }), this.fieldErrors.phone ? m("div", {
      class: "BookingModal-Error"
    }, this.fieldErrors.phone) : null)), m("div", {
      class: "BookingModal-form-row BookingModal-form-row-full"
    }, m("div", {
      class: "BookingModal-field"
    }, m("label", {
      class: "BookingModal-field-label"
    }, this._t('label_has_ski_experience', '是否有滑雪基础')), m("div", {
      class: "BookingModal-radio-group"
    }, m("label", {
      class: "BookingModal-radio"
    }, m("input", {
      type: "radio",
      name: "has_ski_experience",
      value: "true",
      checked: this.form.has_ski_experience === true,
      onchange: () => {
        this.form.has_ski_experience = true;
      }
    }), ' ', this._t('yes', '是')), m("label", {
      class: "BookingModal-radio"
    }, m("input", {
      type: "radio",
      name: "has_ski_experience",
      value: "false",
      checked: this.form.has_ski_experience === false,
      onchange: () => {
        this.form.has_ski_experience = false;
      }
    }), ' ', this._t('no', '否'))))), m("div", {
      class: "BookingModal-form-row BookingModal-form-row-full"
    }, m("div", {
      class: "BookingModal-field"
    }, m("label", {
      class: "BookingModal-field-label"
    }, this._t('label_experience_type', '体验类型')), m("div", {
      class: "BookingModal-radio-group"
    }, m("label", {
      class: "BookingModal-radio"
    }, m("input", {
      type: "radio",
      name: "experience_type",
      value: "single",
      checked: this.form.experience_type === 'single',
      onchange: () => {
        this.form.experience_type = 'single';
      }
    }), ' ', this._t('type_single', '🎿 单板体验')), m("label", {
      class: "BookingModal-radio"
    }, m("input", {
      type: "radio",
      name: "experience_type",
      value: "double",
      checked: this.form.experience_type === 'double',
      onchange: () => {
        this.form.experience_type = 'double';
      }
    }), ' ', this._t('type_double', '⛷️ 双板体验'))))), m("div", {
      class: "BookingModal-form-row BookingModal-form-row-full"
    }, m("div", {
      class: "BookingModal-field"
    }, m("label", {
      class: "BookingModal-field-label"
    }, this._t('label_booking_date', '预约日期')), m("div", {
      class: "BookingModal-date-wrap"
    }, m("input", {
      type: "text",
      class: "BookingModal-input BookingModal-input-text BookingModal-input-date-text",
      placeholder: this._t('field_booking_date_placeholder', '请选择预约日期 *'),
      required: true
    })), this.fieldErrors.booking_date ? m("div", {
      class: "BookingModal-Error"
    }, this.fieldErrors.booking_date) : null)), m("div", {
      class: "BookingModal-actions"
    }, m("button", {
      type: "button",
      class: "Button Button--secondary",
      onclick: () => this.hide(),
      disabled: this.submitting
    }, this._t('cancel', '取消')), m("button", {
      type: "submit",
      class: "Button Button--primary BookingModal-submit",
      disabled: this.submitting
    }, this.submitting ? this._t('submitting', '提交中...') : this._t('submit', '提交预约 →')))));
  }
  async submit() {
    if (this.submitting) return;

    // 前端基础验证 (跟 server ValidationException 字段对齐, SOP 313 跨层对齐)
    //   v0.2.0i.z 改 (辉哥 2026-08-31 13:56 反馈): 加 phone 中国手机号格式 + age 必须是数字 + age 范围
    //   之前 v0.2.0i 时代前端只检查空字段, 后端 v0.2.0i 时代 phone 只检查长度不限数字格式
    //   现在前端加格式验证, 跟后端 CreateBookingController 验证规则 1:1 对齐
    //   优势: user 填错时立即前端反馈, 不需 server round-trip
    this.fieldErrors = {};
    this.formError = '';
    if (!this.form.name || !this.form.name.trim()) this.fieldErrors.name = this._t('error_required', '请填写必填字段');
    // phone: 必填 + 中国手机号 11 位数字 (1[3-9]xxxxxxxxx), 跟 server 端 regex 1:1
    if (!this.form.phone || !this.form.phone.trim()) {
      this.fieldErrors.phone = this._t('error_required', '请填写必填字段');
    } else if (!/^1[3-9]\d{9}$/.test(this.form.phone.trim())) {
      this.fieldErrors.phone = '手机号格式错误, 请输入 11 位数字 (1[3-9]xxxxxxxxx)';
    }
    // age: 可选, 但填了必须是数字 1-150 (跟 server 端 1:1)
    if (this.form.age !== '' && this.form.age !== null && this.form.age !== undefined) {
      if (!/^\d+$/.test(String(this.form.age).trim())) {
        this.fieldErrors.age = '年龄必须是数字';
      } else {
        const ageNum = parseInt(this.form.age, 10);
        if (ageNum < 1 || ageNum > 150) {
          this.fieldErrors.age = '年龄需 1-150 之间';
        }
      }
    }
    if (!this.form.booking_date) this.fieldErrors.booking_date = this._t('error_required', '请填写必填字段');
    if (Object.keys(this.fieldErrors).length > 0) {
      m.redraw();
      return;
    }
    this.submitting = true;
    m.redraw();
    try {
      // SOP 126: m.request 走 vendor, Flarum 2.0 forum API base + path
      const body = {
        name: this.form.name.trim(),
        phone: this.form.phone.trim(),
        // age 空字符串 → null (server filter_var null 直接过)
        age: this.form.age !== '' ? Number(this.form.age) : null,
        has_ski_experience: this.form.has_ski_experience === true,
        experience_type: this.form.experience_type,
        booking_date: this.form.booking_date
      };
      const r = await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/bjxy/bookings',
        body
      });
      if (r && r.ok) {
        this.success = true;
        m.redraw();
      } else {
        this.formError = r && r.error || '提交失败';
        m.redraw();
      }
    } catch (err) {
      // vendor RequestError 没 message, 走 responseText 解析 (SOP 175 同款)
      let errMsg = '提交异常';
      if (err && err.responseText) {
        try {
          const parsed = JSON.parse(err.responseText);
          if (parsed && parsed.errors) {
            // Flarum ValidationException: {errors: {field: msg, ...}}
            this.fieldErrors = parsed.errors;
            errMsg = '';
            // rate_limited 单独显示
            if (parsed.errors.rate_limited) {
              this.formError = parsed.errors.rate_limited;
            } else {
              // 至少有一个字段错误, 不显示全局错误
              this.formError = '';
            }
          } else if (parsed && parsed.error) {
            errMsg = parsed.error;
          } else {
            errMsg = err.responseText;
          }
        } catch (e) {
          errMsg = err.responseText;
        }
      } else if (err && err.status) {
        errMsg = `HTTP ${err.status} 错误`;
      }
      this.formError = this.formError || errMsg;
      m.redraw();
    } finally {
      this.submitting = false;
      m.redraw();
    }
  }
}

// v0.2.0h.e 加 (辉哥 8/29 12:23 反馈 v0.2.0h.d 修法无效, vendor Modal 不调 attrs.onhide):
//   修法: override hide (跟 zpc 2026-08 ziven-post-comment/js/src/forum/index.js 87 行 override(CommentPost.prototype, 'content', ...) 同款)
//   弹 modal 前保存 scrollY (oninit/_savedScrollY=0 + oncreate 刷新成用户实际 scrollY), modal hide 调 original 后双 rAF 强制恢复
//   双 rAF 延迟: 确保 vendor body-scroll-lock clearAllBodyScrollLocks 恢复 body.style 后再覆盖 scrollTo (SOP 218 套路)
//   onremove 兜底 (focus trap / mithril 生命周期不同时序, 实际可能在 hide 后才 onremove)
override(BookingModal.prototype, 'hide', function (original) {
  original();
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      window.scrollTo(0, this._savedScrollY);
    });
  });
});
flarum.reg.add('ziiven-bjxy-website', 'forum/components/BookingModal', BookingModal);